<div edsGrid>
  <div edsSpacing="xl">
    <div class="container">
      <div edsRow class="video-wrapper">
        <div edsCol class="video-wrapper__video-container">
          <div edsSpacing="lg" [innerHTML]="videoEmbed | safeHtml"></div>
        </div>
      </div>
    </div>
  </div>
</div>
